import { render, staticRenderFns } from "./examination-attachments-dialog.vue?vue&type=template&id=06438930&scoped=true"
import script from "./examination-attachments-dialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./examination-attachments-dialog.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./examination-attachments-dialog.vue?vue&type=style&index=0&id=06438930&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06438930",
  null
  
)

export default component.exports